<div class="add-attendence" *ngIf="workType === 'service'">
  <!-- header -->
  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns pt-2">
      <div class="icon mr-2">
        <div class="icon-circle ml-3"><i class="fal fa-edit pt-1"></i></div>
      </div>

      <div class="text">
        <div class="font-18 font-bold black">Edit timelog</div>
        <div class="font-14 font-500 gray-55">For {{ edit?.technician }}, on {{ edit?.createdDate }}</div>
      </div>

      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeAttendenceModal({})"></i>
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <div class="ui-g">
      <div class="ui-g-12">
        <div class="ui-g-7 attendence-left">
          <!-- BEFORE -->
          <div class="widht-97">
            <div class="notification-contact-box flex-column flex-center-start position-relative"
              tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right">
              <!-- header -->
              <div class="width-100p ml-2">
                <div class="font-13">
                  <div _ngcontent-dkt-c1="" class="recommended-heading flex-start-center pt-2 pb-2">
                    <i class="fal font-gray-85 contact-icon flex-center-center"
                      [ngClass]="isBeforeEdit ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                    <span class="recommended-heading-label font-bold font-12 ml-2">BEFORE</span>
                    <div class="horizon-line"></div>
                  </div>
                </div>
              </div>

              <!-- Sub header -->
              <div class="width-100p ml-2">
                <div class="container-header">
                  <div class="container-ro">
                    <div class="font-14 font-bold font-black">{{ before?.ro || '' }}</div>
                    <div class="font-14 font-gray-45">{{ before?.service || '' }}</div>
                  </div>

                  <!-- time -->
                  <div class="container-time">
                    <div class="width-100p" *ngIf="!isBeforeEdit">
                      <span *ngIf="before?.start || before?.end">
                        <ul class="m-0">
                          <li class="node4 bg-primary-color" *ngIf="before?.start"></li>
                          <li class="node4 bg-transparent" *ngIf="!before?.start"></li>

                          <li class="node3 bg-primary-color" *ngIf="before?.end"
                            [ngClass]="{ 'bg-red': isOverlapBefore }"></li>
                          <li class="node3 bg-transparent" *ngIf="!before?.end"></li>
                        </ul>
                        <div>
                          <span class="text-left ml-3">{{ formateTime(before?.start) }} </span>
                          <span class="float-right mr-3"
                            [ngClass]="isOverlapBefore ? 'red pointer hover-underline' : 'font-black'"
                            (click)="showBeforeTime()">{{ formateTime(before?.end) }}</span>
                        </div>
                      </span>
                    </div>

                    <!-- status -->
                    <div class="width-100p" *ngIf="isBeforeEdit">
                      <span class="tech-status font-white approved float-right mr-3 capitalize"
                        [ngClass]="{ approved: before.action === 'completed', unapproved: before.action === 'pause' }">
                        {{ before?.action }}
                      </span>
                    </div>
                  </div>

                  <div class="horizon-line"></div>
                </div>
              </div>

              <!-- Body -->
              <div class="width-100p ml-2 anim" *ngIf="isBeforeEdit">
                <div class="container-header mt-3 mb-3">
                  <div class="container-ro mt-2">
                    <!-- start Time -->
                    <div class="p-zero pl-0 pt-0">
                      <div class="dropdown-icon">
                        <i class="far fa-clock pt-2 font-15"></i>
                        <span class="ml-3 mt-2 font-15">
                          Start time: <span class="ml-1">{{ formateTime(before?.start)}}</span>
                        </span>
                      </div>

                      <div class="">
                        <div class="input-general-settings-wrapper input-default-style margin-zero"></div>
                      </div>
                    </div>
                  </div>

                  <div class="container-time">
                    <!-- End Time -->
                    <div class="p-zero pl-0 pt-0">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-icon">
                          <i class="far fa-clock pt-2 font-15"></i>
                          <span class="ml-2 mt-2 font-15 font-black">End time:</span>
                        </div>

                        <div class="">
                          <div class="input-general-settings-wrapper input-default-style margin-zero">
                            <div class="timepicker-autocomplete">
                              <kendo-timepicker [(value)]="beforeEndDate"
                                (valueChange)="handleEditStartDate('beforeEndDate', $event)"
                                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                              </kendo-timepicker>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isCurrentBeforeEndTime && before?.end">
                        <p class="ml-4 gray-55 font-14 absolute">Currently: {{ formateTime(before?.end) }}</p>
                        <br />
                      </div>

                      <div *ngIf="isOverlapBefore || isOverlapBeforeStartTime">
                        <p class="ml-4 font-14 red absolute">Overlapping detected</p>
                      </div>
                    </div>
                  </div>
                  <div class="horizon-line"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- EDITING -->
          <div class="mt-2 widht-97">
            <div class="notification-contact-box bg-white flex-column flex-center-start mt-2 position-relative"
              tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right">
              <!-- header -->
              <div class="width-100p ml-2">
                <div class="font-13">
                  <div _ngcontent-dkt-c1="" class="recommended-heading flex-start-center pt-2 pb-2">
                    <i class="fal fa-chevron-right font-gray-85 contact-icon flex-center-center"></i>
                    <span class="recommended-heading-label font-bold font-12 ml-2">EDITING</span>
                    <div class="horizon-line"></div>
                  </div>
                </div>
              </div>

              <!-- sub header -->
              <div class="width-100p ml-2">
                <div class="container-header">
                  <div class="container-ro">
                    <div class="font-14 font-bold font-black">{{ edit?.ro || '' }}</div>
                    <div class="font-14 font-gray-45">{{ edit?.service || '' }}</div>
                  </div>

                  <!-- time -->
                  <div class="container-time">
                    <!-- status -->
                    <div class="status-drowdown">
                      <app-dropdown placeholder="Status" theme="border" leftIcon="fal fa-user-hard-hat"
                        position="bottom" field="label" styleClassSelectedView="payment-method-dropdown"
                        [disabled]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress')"
                        [isDropdownIconVisible]="true" scrollHeight="198px" [fontSize]="13" [listItemFontSize]="13"
                        [value]="edit?.action" (appSelect)="onSelectEditServiceStatus($event)"
                        [setPositionDynamically]="false" [options]="techStatuses" [isDropdownIconVisible]="true">
                      </app-dropdown>
                    </div>
                  </div>
                  <div class="horizon-line"></div>
                </div>
              </div>

              <!-- Body -->
              <div class="width-100p ml-2">
                <div class="container-header mt-3 mb-3">
                  <div class="container-time">
                    <!-- Start Time -->
                    <div class="p-zero pl-0 pt-0">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-icon">
                          <i class="far fa-clock pt-2 font-15"></i>
                          <span class="ml-2 mt-2 font-15 font-black">Start time:</span>
                        </div>

                        <div class="">
                          <div class="input-general-settings-wrapper input-default-style margin-zero">
                            <div class="timepicker-autocomplete" tooltipPosition="top"
                              tooltipStyleClass="tech-inprogress-tooltip font-11"
                              [pTooltip]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress') ?  'Service is Inprogress' : ''">
                              <kendo-timepicker [(value)]="editStartDate"
                                [disabled]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress')"
                                (valueChange)="handleEditStartDate('editStartDate', $event)"
                                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                              </kendo-timepicker>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isCurrentEditStartTime && edit?.start">
                        <p class="ml-4 gray-55 font-14 absolute">Currently: {{ formateTime(edit?.start) }}</p>
                        <br />
                      </div>

                      <div *ngIf="isOverlapBefore || isOverlapBeforeStartTime">
                        <p class="ml-4 font-14 red absolute">Overlapping detected</p>
                        <br />
                      </div>

                      <div *ngIf="isInvalidEditStartTime">
                        <p class="ml-4 font-14 red absolute">Invalid Start time</p>
                        <br />
                      </div>
                    </div>
                  </div>

                  <div class="container-ro">
                    <!-- End Time -->
                    <div class="p-zero pl-0 pt-0">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-icon">
                          <i class="far fa-clock pt-2 font-15"></i>
                          <span class="ml-2 mt-2 font-15 font-black">End time:</span>
                        </div>

                        <div class="">
                          <div class="input-general-settings-wrapper input-default-style margin-zero">
                            <div class="timepicker-autocomplete" tooltipPosition="top"
                              tooltipStyleClass="tech-inprogress-tooltip font-11"
                              [pTooltip]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress') ?  'Service is Inprogress' : ''">
                              <kendo-timepicker [(value)]="editEndDate"
                                [disabled]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress')"
                                (valueChange)="handleEditStartDate('editEndDate', $event)"
                                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isCurrentEditEndTime && edit.end">
                        <p class="ml-4 gray-55 font-14 absolute">Currently: {{ formateTime(edit?.end) }}</p>
                        <br />
                      </div>

                      <div *ngIf="isOverlapAfter || isOverlapAfterEndtTime">
                        <p class="ml-4 font-14 red absolute absolute">Overlapping detected</p>
                        <br />
                      </div>

                      <p class="ml-4 font-14 red absolute" *ngIf="isInvalidEditEndTime">Invalid End time</p>
                    </div>
                  </div>
                  <div class="horizon-line"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- After -->
          <div class="mt-2 widht-97">
            <div class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
              tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right">
              <!-- header -->
              <div class="width-100p ml-2">
                <div class="font-13">
                  <div _ngcontent-dkt-c1="" class="recommended-heading flex-start-center pt-2 pb-2">
                    <i class="fal font-gray-85 contact-icon flex-center-center"
                      [ngClass]="isAfterEdit ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                    <span class="recommended-heading-label font-bold font-12 ml-2">AFTER</span>
                    <div class="horizon-line"></div>
                  </div>
                </div>
              </div>

              <!-- sub header -->
              <div class="width-100p ml-2">
                <div class="container-header">
                  <div class="container-ro">
                    <div class="font-14 font-bold font-black">{{ after?.ro }}</div>
                    <div class="font-14 font-gray-45">{{ after?.service }}</div>
                  </div>

                  <!-- time -->
                  <div class="container-time">
                    <div class="width-100p" *ngIf="!isAfterEdit">
                      <ul class="m-0">
                        <li class="node4 bg-primary-color" *ngIf="after?.start"
                          [ngClass]="{ 'bg-red': isOverlapAfter }"></li>
                        <li class="node4 bg-transparent" *ngIf="!after?.start"></li>

                        <li class="node3 bg-primary-color" *ngIf="after?.end"></li>
                        <li class="node3 bg-transparent" *ngIf="!after?.end"></li>
                      </ul>
                      <div>
                        <span class="text-left ml-3"
                          [ngClass]="isOverlapAfter ? 'red pointer hover-underline' : 'font-black'"
                          (click)="showAfterTime()">{{ formateTime(after?.start) }}</span>
                        <span class="float-right mr-3">{{ formateTime(after?.end) }}</span>
                      </div>
                    </div>

                    <!-- status -->
                    <div class="width-100p" *ngIf="isAfterEdit">
                      <span class="tech-status font-white approved float-right mr-3 capitalize"
                        [ngClass]="{ approved: after?.action === 'completed', unapproved: after?.action === 'pause' }">
                        {{ after?.action }}
                      </span>
                    </div>
                  </div>
                  <div class="horizon-line"></div>
                </div>
              </div>

              <!-- body -->
              <div class="width-100p ml-2" *ngIf="isAfterEdit">
                <div class="container-header mt-3 mb-3">
                  <div class="container-time">
                    <!-- Start Time -->
                    <div class="p-zero pl-0 pt-0">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-icon">
                          <i class="far fa-clock pt-2 font-15"></i>
                          <span class="ml-2 mt-2 font-15 font-black">Start time:</span>
                        </div>

                        <div class="">
                          <div class="input-general-settings-wrapper input-default-style margin-zero">
                            <div class="timepicker-autocomplete" tooltipPosition="top"
                              tooltipStyleClass="tech-inprogress-tooltip font-11"
                              [pTooltip]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress') ?  'Service is Inprogress' : ''">
                              <kendo-timepicker [(value)]="afterStartDate"
                                [disabled]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress')"
                                (valueChange)="handleEditStartDate('afterStartDate', $event)"
                                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                              </kendo-timepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isCurrentAfterStartTime && after.start">
                      <p class="ml-4 gray-55 font-14 absolute">Currently: {{ formateTime(after?.start) }}</p>
                      <br />
                    </div>
                    <div *ngIf="isOverlapAfterStartTime || isOverlapAfterEndtTime">
                      <p class="ml-4 font-14 red absolute">Overlapping detected</p>
                      <br />
                    </div>
                    <div *ngIf="isInvalidAfterStartTime">
                      <p class="ml-4 font-14 red absolute">Invalid Start time</p>
                    </div>
                  </div>

                  <div class="container-ro mt-2">
                    <!-- End Time -->
                    <div class="p-zero pl-0 pt-0">
                      <div class="dropdown-icon">
                        <i class="far fa-clock pt-2 font-15"></i>
                        <span class="ml-3 mt-2 font-15">
                          End time: <span class="ml-1">{{formateTime(after?.end)}}</span>
                        </span>
                      </div>

                      <div class="">
                        <div class="input-general-settings-wrapper input-default-style margin-zero">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="horizon-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-5">
          <div class="attendence-right">
            <div class="activity-log-header ml-3">
              <h4>
                Edit history
              </h4>
              <p>All changes ever made to this timelog can be seen here</p>
            </div>
            <div class="act-row">
              <div class="column1 activity-log-container ml-2" *ngFor="let activity of activities">
                <!-- Activity List -->
                <div class="icon1">
                  <ul class="activity-list">
                    <div class="activity-list-item-wrapper">
                      <li class="activity-list-item flex-start-start" tooltipPosition="top"
                        tooltipStyleClass="payment-history-tooltip">
                        <div>
                          <span class="icon">{{ activity?.heading || fetchInitials(activity?.actionBy) }}</span>
                        </div>

                        <div class="flex-column activity-title-wrapper">
                          <p class="mb-0 font-12 text-truncate activity-title font-bold">
                            {{ activity?.actionBy }}
                          </p>

                          <p class="mb-0 font-10 activity-title activity-user-logs">
                            {{ activity?.createdAt | date: 'MMM d, yyyy h:mm a' }}
                          </p>
                        </div>
                      </li>

                      <li class="divider"></li>

                      <li class="node"></li>
                    </div>
                  </ul>
                </div>
                <div class="text1 mr-3">
                  <div class="width-100p">
                    <ul class="m-0">
                      <li class="node2 bg-primary-color" *ngIf="activity?.data?.start"></li>
                      <li class="node2 bg-transparent" *ngIf="!activity?.data?.start"></li>
                      <li class="node1 bg-primary-color" *ngIf="activity?.data?.end"></li>
                      <li class="node1 bg-transparent" *ngIf="!activity?.data?.end"></li>
                    </ul>

                    <div>
                      <span class="text-left ml-7" *ngIf="activity?.data?.start">
                        {{formateTimeWithoutTimezone(activity?.data?.start)}}
                      </span>

                      <span class="float-right mr-18" *ngIf="activity?.data?.end">
                        {{formateTimeWithoutTimezone(activity?.data?.end)}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="close1 mt-3">
                  <span class="tech-status font-white approved capitalize"
                    [ngClass]="{ approved: activity.data?.action === 'completed', unapproved: activity.data?.action === 'pause' }">
                    {{ activity?.data?.action === 'pause' ? 'Paused' : 'Completed' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="ui-g-12 p-zero dialog-footer">
    <div class="attendence-add-footer d-flex justify-content-between width-100p">
      <div>
        <span class="width-100p ml-4" tooltipPosition="top" tooltipStyleClass="tech-inprogress-tooltip font-11"
          [pTooltip]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress') ?  'Service is Inprogress' : ''">
          <app-checkbox [inputId]="'cb-part-add-another'" label="Mark for delete?" [isChecked]="isDeleted"
            [disabled]="(edit?.action === 'inprogress' || edit?.action?.value === 'inprogress')"
            (appChange)="handleMarkdelete($event)"> </app-checkbox>
        </span>
      </div>

      <div class="p-zero text-right float-right">
        <button id="attendence-btn-cancel" class="btn btn-white btn-border pointer mr-1"
          (click)="closeAttendenceModal($event)">
          Cancel
        </button>

        <button id="attendence-btn-save" class="btn btn-primary btn-submit" (click)="onSubmit()">
          <span class="">Save</span>
          <i *ngIf="isLoading" class="fal fa-spinner rotate ml-1"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Clock In/Out Modal -->
<div class="add-attendence" *ngIf="workType === 'clock'">
  <!-- header -->
  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns pt-2">
      <div class="icon mr-2">
        <div class="icon-circle ml-3"><i class="fal fa-edit pt-1"></i></div>
      </div>

      <div class="text">
        <div class="font-18 font-bold black">Edit Clock-in/out time</div>
        <div class="font-14 font-500 gray-55">For {{ edit?.technician }}, on {{ edit?.createdDate }}</div>
      </div>

      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeAttendenceModal({})"></i>
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <div class="ui-g">
      <div class="ui-g-12">
        <div class="ui-g-7 attendence-left">
          <!-- Body -->
          <div class="width-97p ml-2">
            <!-- Start Time -->
            <div class="">
              <div class="">
                <div class="p-zero pl-0 pt-0 border-bottom-gray mt-3">
                  <div class="dropdown-icon ui-g-3">
                    <i class="far fa-clock pt-2 font-15"></i>
                    <span class="ml-2 mt-2 font-15 font-black">Clock-in time:</span>
                  </div>

                  <div class="">
                    <div class="input-general-settings-wrapper input-default-style margin-zero">
                      <div class="timepicker-autocomplete" tooltipPosition="top"
                        tooltipStyleClass="tech-inprogress-tooltip font-11">
                        <kendo-timepicker [(value)]="updateClockStartDate"
                          (valueChange)="handleupdateClockStartDate('updateClockStartDate', $event)"
                          [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                        </kendo-timepicker>
                      </div>
                    </div>
                  </div>

                </div>
                <div *ngIf="isCurrentEditStartTime && updateClockInOut.start">
                  <P class="ml-4 gray-55 font-14 absolute">Currently: {{ formateTime(updateClockInOut?.start) }}</P>
                  <br />
                </div>

                <div *ngIf="startTimeOverLap">
                  <p class="ml-4 font-14 red absolute"></p>
                  <br />
                </div>

                <div *ngIf="isValidClockStartTime">
                  <p class="ml-4 font-14 absolute red mb-2">Invalid Start time</p>
                </div>
              </div>
              <div class="horizon-line"></div>
            </div>

            <!-- End Time -->
            <div class="">
              <div class="">
                <div class="p-zero pl-0 pt-0 border-bottom-gray mt-3">
                  <div class="dropdown-icon ui-g-3">
                    <i class="far fa-clock pt-2 font-15"></i>
                    <span class="ml-2 mt-2 font-15 font-black">Clock-out time:</span>
                  </div>

                  <div class="">
                    <div class="input-general-settings-wrapper input-default-style margin-zero">
                      <div class="timepicker-autocomplete" tooltipPosition="top"
                        tooltipStyleClass="tech-inprogress-tooltip font-11"
                        [pTooltip]="(endTimeValid && isToday && isClockIn) ? techName + ' is already Clocked in ' : ''">
                        <kendo-timepicker [(value)]="updateClockEndDate"
                          [disabled]="endTimeValid && isToday && isClockIn"
                          (valueChange)="handleupdateClockStartDate('updateClockEndDate', $event)"
                          [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                        </kendo-timepicker>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="isCurrentEditEndTime && updateClockInOut.end">
                  <p class="ml-4 gray-55 font-14 absolute">Currently: {{ formateTime(updateClockInOut?.end) }}</p>
                  <br />
                </div>

                <div *ngIf="endTimeOverLap || clockInDetected">
                  <p class="ml-4 font-14 red absolute">Overlapping detected</p>
                  <br />
                </div>

                <div class="ml-4 font-14 absolute red mb-2" *ngIf="isValidClockEndTime">
                  <p>Invalid End time</p>
                </div>
              </div>
              <div class="horizon-line"></div>
            </div>
          </div>
        </div>

        <div class="ui-g-5">
          <div class="attendence-right">
            <div class="activity-log-header ml-3">
              <h4>Edit history</h4>
              <p>All changes ever made to this timelog can be seen here</p>
            </div>

            <div class="act-row">
              <div class="column1 activity-log-container ml-2" *ngFor="let activity of clockActivities">
                <!-- Activity List -->
                <div class="icon2">
                  <ul class="activity-list">
                    <div class="activity-list-item-wrapper">
                      <li class="activity-list-item flex-start-start" tooltipPosition="top"
                        tooltipStyleClass="payment-history-tooltip">
                        <div>
                          <span class="icon">{{ activity?.heading || fetchInitials(activity?.actionBy) }}</span>
                        </div>

                        <div class="flex-column activity-title-wrapper">
                          <p class="mb-0 font-12 text-truncate activity-title font-bold">
                            {{ activity.actionBy }}
                          </p>

                          <p class="mb-0 font-10 activity-title activity-user-logs">
                            {{ activity.createdAt | date: 'MMM d, yyyy h:mm a' }}
                          </p>
                        </div>
                      </li>

                      <li class="divider"></li>

                      <li class="node"></li>
                    </div>
                  </ul>
                </div>

                <div class="text2 mr-3">
                  <div class="width-100p">
                    <ul class="m-0">
                      <li class="node2 bg-primary-color" *ngIf="activity?.data?.start"></li>
                      <li class="node2 bg-transparent" *ngIf="!activity?.data?.start"></li>

                      <li class="node1 bg-primary-color" *ngIf="activity?.data?.end"></li>
                      <li class="node1 bg-transparent" *ngIf="!activity?.data?.end"></li>
                    </ul>

                    <div>
                      <span class="text-left ml-7">{{ formateTimeWithoutTimezone(activity?.data?.start) }}</span>
                      <span class="float-right">{{ formateTimeWithoutTimezone(activity?.data?.end) }}</span>
                    </div>
                  </div>
                </div>

                <div class="close1 mt-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="ui-g-12 p-zero dialog-footer">
    <div class="attendence-add-footer d-flex justify-content-between width-100p">
      <div>
        <span class="width-100p ml-4"></span>
      </div>

      <div class="p-zero text-right float-right">
        <button id="attendence-btn-cancel" class="btn btn-white btn-border pointer mr-1"
          (click)="closeAttendenceModal($event)">
          Cancel
        </button>

        <button id="attendence-btn-save" class="btn btn-primary btn-submit" [disabled]="isFetchingDetails || isLoading"
          (click)="onUpdateClockInOut()"
          [ngClass]="{'disabled': (endTimeValid && workType ==='clock' && isToday && isClockIn) }"
          [pTooltip]="(endTimeValid && workType ==='clock' && isToday && isClockIn) ? techName + ' is already Clocked in ' : ''">
          <span class="">Update</span>
          <i *ngIf="isLoading" class="fal fa-spinner rotate ml-1"></i>
        </button>
      </div>
    </div>
  </div>
</div>
